import type { ReactNode } from 'react';
import { uiText } from '../../i18n';
import { StudioIcon } from './StudioIcon';
import { fileSize, referenceCaps, type StudioReferenceController } from './use-studio-reference';

/** Карточка «Свой референс» первой в ленте (пустая — пунктир «Загрузить картинку»; проверка — круг ожидания; выбрана — «Ваша»). */
export function StudioReferenceCard({ reference, disabled, label = 'Загрузить картинку' }: { reference: StudioReferenceController; disabled?: boolean; label?: string }) {
  const { url, active, checking } = reference;
  return (
    <>
      <button
        type="button"
        className={`bcs-c reference brf-c${!url ? ' pd-own' : ''}${active ? ' on' : ''}${checking ? ' busy' : ''}`}
        aria-pressed={active}
        aria-busy={checking || undefined}
        disabled={disabled}
        onClick={event => reference.press(event.currentTarget)}
      >
        <span className="pc">
          {url ? (
            <img src={url} alt="" />
          ) : (
            <span className="pd-oi">
              <i>
                <StudioIcon kind="photoPlus" />
              </i>
              {uiText(label)}
            </span>
          )}
          {checking && (
            <span className="brf-chk" role="status" aria-label={uiText('Проверяем')}>
              <span>
                <i className="spin" />
              </span>
            </span>
          )}
          {active && !checking && (
            <span className="brf-b">
              <StudioIcon kind="check" />
              {uiText('Ваша')}
            </span>
          )}
          <i className="ck" aria-hidden="true">
            <StudioIcon kind="check" />
          </i>
        </span>
        <b>{uiText('Свой референс')}</b>
      </button>
      {reference.hidden}
    </>
  );
}
/** Плашка под лентой: строка файла (миниатюра, имя, размер, «Заменить», «Убрать») и строка со щитом; подсказка отказа. */
export function StudioReferencePlate({ reference, use = 'style', extra }: { reference: StudioReferenceController; use?: string; extra?: ReactNode }) {
  return (
    <div className="brf-p">
      {reference.active && (
        <div className="brf-pi">
          <div className="pf-cap">
            <span className="th">{reference.url && <img src={reference.url} alt="" />}</span>
            <span className="m">
              <b>{reference.meta?.name ?? uiText('Свой референс')}</b>
              <span>{reference.checking ? uiText('Проверяем картинку') : reference.meta ? fileSize(reference.meta.size) : uiText('Загружено')}</span>
            </span>
            <button type="button" className="pf-rep" onClick={reference.replace}>
              {uiText('Заменить')}
            </button>
            <button type="button" className="brf-ib" aria-label={uiText('Убрать картинку')} onClick={reference.remove}>
              {uiText('Убрать')}
            </button>
          </div>
          <p className="bc-cap">
            <StudioIcon kind="check" />
            <span>{uiText(referenceCaps[use] ?? referenceCaps.style)}</span>
          </p>
          {extra}
        </div>
      )}
      {reference.problem && (
        <p className="studio-settings-tip" role="alert">
          {uiText(reference.problem)}
        </p>
      )}
      {reference.consentSheet}
    </div>
  );
}
